import { Plus } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { ProjectEquipmentGroupWithAssignments } from "@/hooks/useProjectEquipment";

interface EquipmentGroupSelectProps {
  groups: ProjectEquipmentGroupWithAssignments[];
  value: string | null;
  onChange: (groupId: string | null) => void;
  /** Called to auto-create a new group; should return the new group id. */
  onCreateGroup?: () => void;
}

export function EquipmentGroupSelect({
  groups,
  value,
  onChange,
  onCreateGroup,
}: EquipmentGroupSelectProps) {
  return (
    <Select
      value={value ?? "__none__"}
      onValueChange={(v) => {
        if (v === "__create__") {
          onCreateGroup?.();
        } else {
          onChange(v === "__none__" ? null : v);
        }
      }}
    >
      <SelectTrigger className="h-7 text-sm w-full min-w-[100px]">
        <SelectValue placeholder="—" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">—</SelectItem>
        {groups.map((g) => (
          <SelectItem key={g.id} value={g.id}>
            {g.name}
          </SelectItem>
        ))}
        {onCreateGroup && (
          <SelectItem value="__create__">
            <span className="flex items-center gap-1">
              <Plus className="h-3 w-3" />
              New group
            </span>
          </SelectItem>
        )}
      </SelectContent>
    </Select>
  );
}
